// clearLivestreamCounterTimer.js
'use strict';

import getOperationData from '../selector/getOperationData.js';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';
import { PRESET_PREVIEW, PRESET_SD } from '../resource/liveStreamConstants.js';

/**
 * Clear livestream counter timer
 * @kind action
 * @param {string} {streamId} - stream id.
 * @return {Promise} Action promise.
 */
const clearLivestreamCounterTimer =
  ({ streamId }) =>
  async (dispatch, getState) => {
    if (!streamId) return dispatch({ type: '' });

    const existedPreviewTimerId = getOperationData(
      getState(),
      ['timer', 'livestream', streamId, 'counters'],
      PRESET_PREVIEW
    );
    const existedSdTimerId = getOperationData(
      getState(),
      ['timer', 'livestream', streamId, 'counters'],
      PRESET_SD
    );
    clearTimeout(existedPreviewTimerId);
    clearTimeout(existedSdTimerId);
    dispatch({
      type: MERGE_OPERATION_DATA,
      payload: {
        selectPath: ['timer', 'livestream', streamId, 'counters'],
        data: {
          [PRESET_PREVIEW]: null,
          [PRESET_SD]: null,
        },
      },
    });
  };

export default clearLivestreamCounterTimer;
